import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  containerDark: {
    backgroundColor: theme.colors.card_background_primary_editable,
    padding: theme.spacing(6, 8)
  },
  container: {
    width: '100%',
    marginBottom: 0
  },
  mortgagesContainer: {
    padding: theme.spacing(0, 6, 3, 8),
    paddingTop: 0,
    backgroundColor: theme.colors.card_background_primary_editable,
    borderTop: `1px solid ${theme.colorPalette.white}`,
    width: '100%'
  },
  leftItem: {
    paddingRight: theme.spacing(5)
  },
  rightItem: {
    paddingLeft: theme.spacing(5)
  },
  streetMapText: {
    color: `${theme.colorPalette.orange_50} !important`,
    cursor: 'pointer',
    textDecoration: 'none',
    fontSize: 12
  },
  sqFtErrorSpacing: {
    marginBottom: 70
  },
  notification: {
    margin: 0,
    boxShadow: 'none',
    textAlign: 'start'
  },
  rceValues: {
    gap: theme.spacing(2),
    paddingTop: theme.spacing(0.85)
  },
  coverageAmount: {
    marginTop: 6
  },
  notificationText: {
    display: 'flex',
    direction: 'column',
    paddingLeft: theme.spacing(8),
    paddingTop: theme.spacing(2),
    fontSize: 12,
    fontWeight: 400
  },
  buttonContainer: {
    alignItems: 'center'
  },
  iconStyle: {
    height: 24,
    width: 24,
    marginRight: theme.spacing(1)
  },
  cardStyling: {
    boxShadow: 'none',
    // marginTop 0 is to override some other margin making the card be too close
    marginTop: 0,
    marginBottom: theme.spacing(4),
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(2),
    color: theme.colorPalette.green_100,
    fontSize: 12
  },
  button: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    fontSize: 12,
    borderRadius: 0,
    paddingLeft: theme.spacing(0)
  },
  // external link styles
  streetMapLink: {
    color: theme.colorPalette.orange_50,
    cursor: 'pointer',
    textDecoration: 'none',
    fontSize: 14
  },
  links: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    gap: theme.spacing(2)
  },
  linkAndIcon: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2)
  }
}));

export default useStyles;
